// src/components/Benefits/Benefits.js
import React from 'react';
import styled from 'styled-components';
import { fadeIn } from '../shared/animations';
import { FaHandshake } from 'react-icons/fa';
import { FiDollarSign, FiGlobe } from 'react-icons/fi';
import SectionTitle from '../shared/SectionTitle';

// Styled Components
const BenefitsContainer = styled.section`
  padding: 100px 20px;
  background: #f8f9ff;
  
  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

const BenefitCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 15px 40px -10px rgba(21, 28, 72, 0.1);
  transition: all 0.4s ease;
  text-align: center;
  animation: ${fadeIn} 0.6s ease-out forwards;
  animation-delay: ${props => props.delay * 0.1}s;
  opacity: 0;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 50px -10px rgba(21, 28, 72, 0.2);
  }
`;

const BenefitIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #151c48, #5ab9d3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  color: white;
  font-size: 2rem;
  box-shadow: 0 10px 30px rgba(90, 185, 211, 0.3);
`;

const BenefitTitle = styled.h3`
  font-size: 1.5rem;
  color: #151c48;
  margin-bottom: 15px;
  font-weight: 700;
`;

const BenefitDescription = styled.p`
  color: #5f6c84;
  line-height: 1.6;
`;

// Data - Pode ser movido para um arquivo separado se necessário
const BENEFITS_DATA = [
  {
    icon: <FaHandshake size={30} />,
    title: 'Parceiros Verificados',
    description: 'Trabalhamos apenas com consultores e empresas cuidadosamente selecionados e verificados para garantir a melhor experiência.'
  },
  {
    icon: <FiDollarSign size={30} />,
    title: 'Economia de Tempo e Dinheiro',
    description: 'Compare várias opções em um só lugar e escolha a que melhor se adapta ao seu orçamento e necessidades.'
  },
  {
    icon: <FiGlobe size={30} />,
    title: 'Suporte Completo',
    description: 'Acompanhamos você em todas as etapas da sua realocação, desde a documentação até a instalação em Portugal.'
  }
];

// Componente de Card individual para melhor reutilização
const BenefitItem = ({ delay, icon, title, description }) => (
  <BenefitCard delay={delay}>
    <BenefitIcon>{icon}</BenefitIcon>
    <BenefitTitle>{title}</BenefitTitle>
    <BenefitDescription>{description}</BenefitDescription>
  </BenefitCard>
);

// Componente Principal
const Benefits = () => {
  return (
    <BenefitsContainer>
      <SectionTitle>Por que escolher a Realoca Fácil?</SectionTitle>
      <BenefitsGrid>
        {BENEFITS_DATA.map((benefit, index) => (
          <BenefitItem
            key={benefit.title}
            delay={index}
            icon={benefit.icon}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
      </BenefitsGrid>
    </BenefitsContainer>
  );
};

export default Benefits;